import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import { css } from "styled-components";

accountMessagesStyles.messagesAccordionSection = {
    panelProps: {
        css: css`
            max-height: 500px;
            overflow-y: unset;
        `,
    },
}
accountMessagesStyles.messageCardGridItem = {
    width: 12,
        css: css`
        padding: 7px 25px;
        `,
}
accountMessagesStyles.messageFilterGridItem = {
    width: 12,
        css: css`
            padding: 9px 15px;
        `,
}
